import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig } from 'config/config'; // Importing devConfig for permission checks

/**
 * Class representing the FilterPromotionalCodesView.
 * @extends JetView
 */
export default class FilterPromotionalCodesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section of the form with user ID and Link ID fields
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Id', // User ID field
                    type: 'number',
                    label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'), // Localized label
                    hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Permission check
                    css: 'prm-filterByUser',
                    labelPosition: 'top',
                    placeholder: _('ID Usuario'), // Placeholder text
                },
                {
                    view: 'text',
                    name: 'LinkId', // Link ID field
                    label: _('LinkId'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('LinkId'), // Placeholder text
                },
            ],
        };

        // Center left section of the form with Name and Code fields
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Name', // Name field
                    label: "<span class='icon-user'></span>" + _('Nombre'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Nombre'), // Placeholder text
                    hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Permission check
                    css: 'prm-filterByUser',
                },
                {
                    view: 'text',
                    name: 'Code', // Code field
                    label: _('Código'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Código'), // Placeholder text
                },
            ],
        };

        // Center right section of the form with Login and Created Date fields
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Login', // Login field
                    label: _('Login'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Login'), // Placeholder text
                    hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Permission check
                    css: 'prm-filterByUser',
                },
                {
                    view: 'text',
                    name: 'CreatedLocalDate', // Created Date field
                    id: 'Datepicker', // ID for the datepicker
                    css: 'reportrange',
                    readonly: true, // Read-only field
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Creación'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
            ],
        };

        // Right section of the form with activation status field
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect',
                    name: 'IsActivate', // Activation status field
                    label: "<span class='icon-state'></span>" + _('Estado'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    value: '', // Default value
                    options: [
                        { id: '0', value: _('Todos') }, // All option
                        { id: 'A', value: _('Activo') }, // Active option
                        { id: 'I', value: _('Inactivo') }, // Inactive option
                    ],
                },
            ],
        };

        // Upper section containing all form fields
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right, right], // Layout of columns
                },
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 5,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Añadir Código'), // Add Code button
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        this.app.callEvent('addCode:button', [{}]); // Event for adding code
                    },
                },
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clear form fields
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Consult button
                    hotkey: 'enter', // Shortcut key
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('promotionalCodes:filter', [
                            filterdata, // Event for filtering promotional codes
                        ]);
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, buttons], // Combine upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }
}

// FILE DOCUMENTED
